import { CloseNotificationItem } from 'layout/inbox-notifications/close/CloseNotificationItem';

import type { InboxBaseNotification } from 'types/inbox-notifications/InboxNotifications';
import type { CloseNotification } from 'types/inbox-notifications/close/CloseNotification';

export function InboxNotificationItem({
  item,
}: {
  item: InboxBaseNotification;
}) {
  const notificationType = item.type;
  const [module, ...restOfType] = notificationType.split('.');

  switch (module) {
    case 'close':
      return (
        <CloseNotificationItem
          type={restOfType}
          item={item as CloseNotification}
        />
      );
    default:
      return <div>Unknown notification type: {notificationType}</div>;
  }
}
